import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const GetTemplateInfoQuery: GraphQLTaggedNode = graphql`
	query GetTemplateInfoQuery($id: ID!) {
		templateInfo(id: $id) {
			author
			blueprintModuleCompleteKey
			categoryIds
			contentBlueprintId
			description
			hasGlobalBlueprintContent
			hasWizard
			iconURL
			darkModeIconURL
			isFavourite
			isNew
			isPromoted
			itemModuleCompleteKey
			link
			links {
				base
				context
			}
			name
			recommendationRank
			spaceKey
			styleClass
			templateId
			templateType
		}
	}
`;
